module.exports = __webpack_public_path__ + "static/media/logoInvt.27022b9b.png";